import i18n from '../../../i18n';

export const initialState = {
    i18n,
    tasksList: [],
    taskFilter: "",
    myTaskFilter: null,
    statusList: [
        { translationKey: "task.todo", value: "todo" },
        { translationKey: "task.inProgress", value: "inProgress" },
        { translationKey: "task.completed", value: "completed" },
    ],
};

const state = { ...initialState };

export default state;